import { faTriangle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { memo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setComparisonOffset } from "redux/actions";

const offsetSelector = (state) => state.trackGeometry.comparisonOffset;

const directions = { left: "LEFT", right: "RIGHT", up: "UP", down: "DOWN" };

const ComparisonGraphAlignment = memo(({ comparisonSession }) => {
    const { horizontal, vertical } = useSelector(offsetSelector);
    const dispatch = useDispatch();

    const handleOffset = useCallback(
        (direction) => {
            const newOffset = { horizontal, vertical };

            // There is no reason behind 0.25 & 5, they just move the chart in nice increments
            switch (direction) {
                case directions.up:
                    newOffset.vertical += 0.25;
                    break;
                case directions.down:
                    newOffset.vertical -= 0.25;
                    break;

                // y = f(x + a) is a translation of
                // y = f(x) by -a units along the x axis
                // So if left unflipped the experience will be unintuitive
                case directions.left:
                    newOffset.horizontal += 5;
                    break;
                case directions.right:
                    newOffset.horizontal -= 5;
                    break;
                default:
                    break;
            }

            dispatch(setComparisonOffset(newOffset));
        },
        [dispatch, horizontal, vertical],
    );

    if (!comparisonSession) return null;

    return (
        <div className="GeometryComparisonControls">
            <div
                className="GeometryToolbarButton small"
                style={{ gridArea: "up" }}
                onClick={() => handleOffset(directions.up)}>
                <FontAwesomeIcon icon={faTriangle} />
            </div>
            <div
                className="GeometryToolbarButton small"
                style={{ gridArea: "left" }}
                onClick={() => handleOffset(directions.left)}>
                <FontAwesomeIcon
                    icon={faTriangle}
                    rotation={270}
                />
            </div>
            <div
                className="GeometryToolbarButton small"
                style={{ gridArea: "right" }}
                onClick={() => handleOffset(directions.right)}>
                <FontAwesomeIcon
                    icon={faTriangle}
                    rotation={90}
                />
            </div>
            <div
                className="GeometryToolbarButton small"
                style={{ gridArea: "down" }}
                onClick={() => handleOffset(directions.down)}>
                <FontAwesomeIcon
                    icon={faTriangle}
                    rotation={180}
                />
            </div>
        </div>
    );
});

export default ComparisonGraphAlignment;
